import React from "react";
import PropTypes from "prop-types";
import styles from "./Badge.module.css";

/**
 * Componente reutilizável Badge que aceita diferentes cores
 */
function Badge({ children, color, rounded = false, ...props }) {
  return (
    <span
      className={`${styles.badge} ${styles[color]} ${rounded ? styles.rounded : ""}`}
      {...props}
    >
      {children}
    </span>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "orange",
  ]).isRequired,
  rounded: PropTypes.bool,
};

export default Badge;
